import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=5f658402"
import script from "./AppSwitch.vue?vue&type=script&lang=ts"
export * from "./AppSwitch.vue?vue&type=script&lang=ts"
import style0 from "./AppSwitch.vue?vue&type=style&index=0&id=5f658402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports